// React
import React from "react";
import PropTypes from "prop-types";
// i18n
import { withNamespaces } from "react-i18next";
// moment
import moment from "moment";
// Style
import styles from "./Item.css";
// Helpers
import { localeCurrencyFormatter } from "../../../../../../../services/helper";
// Components
import Tooltip from "../../../../../../../components/Tooltip";

function Item({ item, handleRowClick, t }) {
  const numberOfParts = item.examinationParts.length;
  const { maxBookedExams } = item;

  return (
    <div style={styles.item} className="well">
      <div style={styles.date}>{item.date}</div>

      <p style={styles.city}>{item.city}</p>
      <div style={{ marginBottom: 0 }}>
        {t(`modules.localization.register.authenticated.exams.startTime`, {
          startTime: moment(item.startTime, `HH:mm:ss`).format(`HH:mm`)
        })}
        <Tooltip
          message={t(
            `modules.localization.register.authenticated.exams.toolTipStartTimeUnguaranteed`
          )}
          position="right"
        >
          <a className="btn btn-link">
            <i className="fa fa-info" />
          </a>
        </Tooltip>
      </div>
      <p style={styles.location}>{item.name || <br />}</p>
      <div>
        <hr style={{ ...styles.hr }} />
        {item.examinationParts.map((ep, index) => {
          const isLastItem = item.examinationParts.length - 1 === index;

          return (
            <div
              key={ep.examPartId}
              style={{
                ...styles.title,
                ...(isLastItem && { paddingBottom: 0 })
              }}
            >
              <span style={{ wordBreak: `break-word` }}>
                {ep.examName}
                {` `}
                <em style={{ fontSize: 13 }}>({ep.examDuration} Min)</em>
              </span>
              {Boolean(ep.examPrice) && (
                <span style={styles.itemPrice}>
                  {localeCurrencyFormatter({
                    locale: item.locale,
                    currency: item.currency,
                    value: ep.examPrice
                  })}
                </span>
              )}
            </div>
          );
        })}
        <hr style={styles.hr} />
        <div style={styles.bottomContainer}>
          {item.canHaveInterruption && (
            <div
              style={{
                ...styles.warningContainer,
                backgroundColor: `#FF8F80`
              }}
            >
              {t(
                `modules.localization.register.authenticated.exams.stationChangeAndInterruptionPossible`
              )}
            </div>
          )}
          {numberOfParts !== maxBookedExams && (
            <div style={styles.warningContainer}>
              {t(`modules.localization.register.authenticated.exams.requestedExamBookedThisDay`, {
                maxBookedExams,
                numberOfParts
              })}
            </div>
          )}
          <div
            style={{
              ...styles.buttonContainer,
              ...styles.spaceBetween
            }}
          >
            <button className="btn btn-primary" type="button" onClick={handleRowClick(item)}>
              {t(`modules.localization.register.authenticated.exams.details`)}
            </button>
            {Boolean(item.totalPrice) &&
              localeCurrencyFormatter({
                currency: item.currency,
                locale: item.locale,
                value: item.totalPrice
              })}
          </div>
        </div>
      </div>
    </div>
  );
}

Item.defaultProps = {
  item: {
    examinationParts: []
  }
};

Item.propTypes = {
  handleRowClick: PropTypes.func.isRequired,
  item: PropTypes.shape({
    city: PropTypes.string,
    currency: PropTypes.string.isRequired,
    date: PropTypes.string,
    email: PropTypes.string,
    examinationDataId: PropTypes.number,
    examinationParts: PropTypes.array.isRequired,
    locale: PropTypes.string.isRequired,
    locationId: PropTypes.number,
    name: PropTypes.string,
    postalCode: PropTypes.string,
    street: PropTypes.string,
    totalPrice: PropTypes.number,
    www: PropTypes.string
  }),
  t: PropTypes.func.isRequired
};

export default withNamespaces()(Item);
